module.exports = __webpack_public_path__ + "static/media/sale-mtc.fa8b5ad4.png";